export default "__VITE_ASSET__DlCx64XB__"